/* eslint-disable @typescript-eslint/no-explicit-any */

import { Box, Flex, Icon, Input, FormControl, FormErrorMessage } from '@chakra-ui/react';
import { Control, Controller, FieldErrors, useWatch } from 'react-hook-form';
import CustomButton from '@/components/common/Button';
import DirectRightIcon from '@/assets/svg/direct-right.svg?react';

interface InputAreaProps {
  control: Control<{ content: string }>;
  handleSubmit: any;
  errors: FieldErrors<{ content: string }>;
}

const InputArea = ({ control, handleSubmit, errors }: InputAreaProps) => {
  const message = useWatch({
    control,
    name: 'content',
    defaultValue: '',
  });
  return (
    <Box p={3} px={5} bg={'background.secondary'} borderTop={'1px'} borderColor={'border.default'}>
      <form onSubmit={handleSubmit}>
        <Flex gap={1}>
          <FormControl isInvalid={!!errors.content}>
            <Controller
              name="content"
              control={control}
              rules={{ required: 'Message cannot be empty' }}
              render={({ field }) => (
                <Input
                  {...field}
                  value={field.value || ''}
                  height={'40px'}
                  border={'1px'}
                  borderColor={'border.default'}
                  placeholder="Type here..."
                  bg={'white'}
                  fontSize={'sm'}
                  fontWeight={'semibold'}
                  _focus={{
                    borderColor: 'border.default',
                    boxShadow: 'none',
                  }}
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              )}
            />
            <FormErrorMessage>{errors.content?.message}</FormErrorMessage>
          </FormControl>

          <CustomButton type="submit" isDisabled={!message.trim()} p={2}>
            <Icon boxSize={'16px'}>
              <DirectRightIcon />
            </Icon>
          </CustomButton>
        </Flex>
      </form>
    </Box>
  );
};

export default InputArea;
